const dataPlanExtension = {
  dataPlanExtension: {
    heading: "Extension du forfait data du Mobile Connect",
    cellModemIMEI: "Numéro IMEI du modem cellulaire",
    siteName: "Nom du système",
    siteAddress: "Adresse du système",
    cellPlanEndDate: "Date de fin du plan de modem cellulaire",
    daysToExpiry: "Jours avant expiration",
    currentPlanStatus: "Statut du plan actuel",
    gatewaySNo: "Numéro de série de la passerelle",
    paymentStatus: "Statut du paiement",
    lastDateOfPurchase: "Dernière date d'achat",
    extendDataPlan: "Prolonger le plan de données",
    purchasedBy: "Acheté par",
    purchasedFrom: "Acheté à",
    siteId: "ID du système",
    orderNo: "numéro de commande",
    footer: 'Extension du forfait data du Mobile Connect',
    total: 'Total',
    record: 'enregistrements',
    records: 'enregistrements',
    show: 'Afficher',
    enphase_store: 'Enphase Store',
    orderSummary: 'Résumé de la commande.',
    confirmSelection: 'Veuillez confirmer votre sélection ci-dessous',
    noOfCellModems: 'Nombre de modems cellulaires',
    years: 'Années',
    pricePerSite: 'Prix par site',
    cancel:'Annuler',
    submit:'Soumettre',
    back: 'Retour',
    noTokens: '** Pas de modems cellulaires disponibles **',
    redirectToStoreText: 'Redirection vers la Enphase store ! Veuillez patienter... !',
    toolTipExtensionInfo: "Seuls les plans de modem cellulaires dont la date d'expiration est inférieure à 180 jours sont éligibles à une prolongation.",
    allCellModems: 'Tous les modems cellulaires',
    dataplanTitleTooltip: 'This is an extension to Enphase monitoring, software/firmware upgrades, and other remote services offered via your existing AT&T cell modem. This extension will enable you to continue using the same physical hardware, beyond its 5-year term you had originally purchased, by renewing its connectivity instead of having to purchase a new physical device.',
    eligibleCellModems: 'Les modems cellulaires éligibles',
    nonAdminInfo: "Veuillez contacter l'administrateur pour prolonger le plan de données d'un modem cellulaire.",
    select: 'Sélectionner',
    typeToSearch: 'Tapez pour rechercher',
    dataPlanExtensionSuccess: "L'extension du forfait data du mobile connect est réussie. Le paiement peut prendre un certain temps avant d'apparaître dans le tableau de bord.",
    expired: 'Expiré',
    active: 'Actif',
    failed: "Paiement échoué",
    pending: "Traitement du paiement",
    success: "Paiement réussi",
  }
}

export default dataPlanExtension